import React, { useEffect, useRef, useState } from "react";

function TalkToPopup() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [popup, setPopup] = useState({
    show: false,
    type: "",
    message: "",
  });

  const showPopup = (type, message) => {
    setPopup({ show: true, type, message });

    setTimeout(() => {
      setPopup({ show: false, type: "", message: "" });
    }, 3000);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    const name = formData.get("name")?.trim() || "";
    const rawEmail = formData.get("email") || "";
    const rawPhone = formData.get("phone") || "";
    const message = formData.get("message")?.trim() || "";

    const email = rawEmail.trim().toLowerCase();
    const phone = rawPhone.replace(/\D/g, "").slice(-10);

    // ✅ VALIDATION (correct order)

    if (!name || name.length < 2) {
      return showPopup("error", "Please enter your name");
    }

    if (!email) {
      return showPopup("error", "Please enter your email");
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return showPopup("error", "Enter valid email");
    }

    if (!phone) {
      return showPopup("error", "Please enter mobile number");
    }

    if (!/^[6-9]\d{9}$/.test(phone)) {
      return showPopup("error", "Enter valid 10-digit mobile number");
    }

    if (!message) {
      return showPopup("error", "Enter project details");
    }

    // ✅ API CALL
    setLoading(true);
    setSuccess(false);

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbzWtv_L5Yr--Z5P7XLuVHzvj202d59HVpHGvIugwYlaOwUy76BkirZFw2qzD251IAiMFQ/exec",
        {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name, email, phone, message }),
        },
      );

      // setSuccess(true);
      // showPopup("success", "Message sent successfully 🚀");
      // e.target.reset();
      setSuccess(true);
      e.target.reset();

      // close both popups
      closeModal(); // ✅ this sets localStorage
      setSideOpen(false);

      // small delay for smooth UX
      setTimeout(() => {
        showPopup("success", "Message sent successfully 🚀");
      }, 300);
    } catch (err) {
      console.error(err);
      showPopup("error", "Something went wrong!");
    }

    setLoading(false);
  };

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [sideOpen, setSideOpen] = useState(false);
  const sideRef = useRef(null);

  const [modalOpen, setModalOpen] = useState(false);
  const modalRef = useRef(null);


  useEffect(() => {
    function handleHashClick(e) {
      const anchor = e.target.closest('a[href="#"]');

      if (anchor) {
        e.preventDefault();

        // open popup
        setModalOpen(true);
      }
    }

    document.addEventListener("click", handleHashClick);

    return () => {
      document.removeEventListener("click", handleHashClick);
    };
  }, []);
  useEffect(() => {
    const popupClosed = localStorage.getItem("talkPopupClosed");

    if (popupClosed === "true") return; // extra safety

    const timer = setTimeout(() => {
      setModalOpen(true);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  const closeModal = () => {
    setModalOpen(false);
    localStorage.setItem("talkPopupClosed", "true");
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (sideRef.current && !sideRef.current.contains(event.target)) {
        setSideOpen(false);
      }
    }

    if (sideOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [sideOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    }

    if (modalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "";
    };
  }, [modalOpen]);

  useEffect(() => {
    function handleEsc(e) {
      if (e.key === "Escape") {
        setSideOpen(false);
        closeModal();
      }
    }

    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <>
      {!sideOpen && (
        <div className="side-button" onClick={() => setSideOpen(true)}>
          <span className="side-text">Get a Call Back</span>
          <div className="side-icon">📞</div>
        </div>
      )}

      {sideOpen && (
        <div className="blur-overlay" onClick={() => setSideOpen(false)}></div>
      )}

      <div ref={sideRef} className={`left-popup ${sideOpen ? "active" : ""}`}>
        <div className="popup-header">
          <h4>Let's Talk About Your Project!</h4>
          <span className="popup-close-btn" onClick={() => setSideOpen(false)}>
            <button className="talk-close" onClick={() => setModalOpen(false)}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </span>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="pt-3">
            <input
              name="name"
              type="text"
              placeholder="John Doe"
            // type="text"
            // placeholder="Full Name"
            // value={form.name}
            // onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
          </div>
          <div className="pt-2">
            <div className="phone-field">
              <span>🇮🇳+91</span>
              <input
                name="phone"
                type="tel"
                placeholder="Mobile Number"
                pattern="[0-9]{10}"
                maxLength="10"
                required
              />
            </div>
          </div>
          <div>
            <input
              name="email"
              type="email"
              placeholder="john@example.com"
            // type="email"
            // placeholder="Email"
            // value={form.email}
            // onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
          </div>
          <div className="pt-2">
            <textarea
              name="message"
              placeholder="Tell us about your project..."
            // placeholder="Please Share Your Business Requirements"
            // value={form.message}
            // onChange={(e) => setForm({ ...form, message: e.target.value })}
            />
          </div>
          {/* <button type="submit" className="submit-btn" onClick={handleSubmit}>
            Call Me Now!
          </button> */}
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? (
              <span className="loader"></span>
            ) : (
              <span> Call Me Now!</span>
            )}
          </button>
        </form>
      </div>

      <div className={`talk-overlay ${modalOpen ? "active" : ""}`} />

      <div ref={modalRef} className={`talk-modal ${modalOpen ? "active" : ""}`}>
        <button className="talk-close" onClick={closeModal}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className="talk-modal-inner">
          <div className="talk-left">
            <div className="talk-illustration">
              <img
                src="/assets/img/illustration/talk_to_us_3d.png"
                alt="Talk to Expert"
              />
            </div>
            <h3 className="talk-left-title">Let's Build Something Amazing</h3>
            <p className="talk-left-desc">
              Our Web3 experts are ready to turn your vision into reality. Get a
              free consultation today.
            </p>
            <div className="talk-contact-badges">
              <div className="talk-badge">
                <i className="fas fa-envelope"></i>
                <span>sales@xeertechnology.com</span>
              </div>
              <div className="talk-badge">
                <i className="fab fa-whatsapp"></i>
                <span>+91 7383847632</span>
              </div>
            </div>
          </div>

          <div className="talk-right">
            <h4 className="talk-form-title">Get a Free Consultation</h4>
            <p className="talk-form-subtitle">
              Fill in your details and our team will reach out within 24 hours.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="talk-field">
                <label>Full Name</label>
                <input
                  name="name"
                  type="text"
                  placeholder="John Doe"
                // type="text"
                // placeholder="John Doe"
                // value={form.name}
                // onChange={(e) => setForm({ ...form, name: e.target.value })}
                />
              </div>
              <div className="talk-field">
                <label>Email Address</label>
                <input
                  name="email"
                  type="email"
                  placeholder="john@example.com"
                // type="email"
                // placeholder="john@example.com"
                // value={form.email}
                // onChange={(e) => setForm({ ...form, email: e.target.value })}
                />
              </div>
              <div className="talk-field-row">
                <div className="talk-field">
                  <label>Phone</label>
                  <div className="talk-phone-input">
                    <span className="talk-country-code">🇮🇳 +91</span>
                    <input
                      name="phone"
                      type="tel"
                      placeholder="Mobile Number"
                    // type="tel"
                    // placeholder="Mobile Number"
                    // value={form.phone}
                    // onChange={(e) =>
                    //   setForm({ ...form, phone: e.target.value })
                    // }
                    />
                  </div>
                </div>
              </div>
              <div className="talk-field">
                <label>Project Details</label>
                <textarea
                  name="message"
                  placeholder="Tell us about your project..."
                // placeholder="Please Share Your Business Requirements"
                // value={form.message}
                // onChange={(e) =>
                //   setForm({ ...form, message: e.target.value })
                // }
                />
              </div>
              {/* <button type="submit" className="talk-submit-btn">
                <span>Send Message</span>
                <i className="fas fa-paper-plane"></i>
              </button> */}
              <button
                type="submit"
                className="talk-submit-btn"
                disabled={loading}
              >
                {loading ? (
                  <span className="loader"></span>
                ) : (
                  <span>Send Message</span>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
      {popup.show && (
        <div className="popup-overlay">
          <div className={`popup-card ${popup.type}`}>
            <div className="popup-icon">
              {popup.type === "success" ? "✔" : "!"}
            </div>

            <h3>{popup.type === "success" ? "Success" : "Error"}</h3>

            <p>{popup.message}</p>

            <div className="popup-progress"></div>
          </div>
        </div>
      )}
    </>
  );
}

export default TalkToPopup;
